export default __webpack_public_path__ + "static/media/slide_posgrados.64fa79c5.png";